// extracted by mini-css-extract-plugin
export default {"container":"Sider_container__QC4Ra","icon":"Sider_icon__zgZ4N","icon1":"Sider_icon1__lHmGq"};